module.exports = __webpack_public_path__ + "img/hotelFamily-1.80b9bb10.jpg";